import { gql } from 'src/__generated__'

export default gql(`
  mutation removeComment($id: Int!) {
    removeComment(id: $id)
  }
`)
